module.exports = __webpack_public_path__ + "img/pg3-article3-c2.c9263e2d.png";